import { filterId } from "app/area/subscriber-groups/list/constants";
import { fieldType } from "app/area/search-filters/constants";
import { CustomFilterType, Filter, FilterType } from "app/area/search-filters/filters/types";
import { SubscriberGroupsTranslation } from "app/area/subscriber-groups/constants";
import { endpoints } from './endpoints';

export const subscriberGroupFilters = (
  translation: SubscriberGroupsTranslation
): Filter[] => [
  {
    id: filterId.userMember,
    label: translation.user_filter,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.code,
        optionsEndpoint: endpoints.userMemberOptions,
        optionsParams: { displayNotSelected: true }
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.externalMemberName,
    label: translation.member_name_filter,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.text,
        includeInSummary: true
      }
    ],
    type: FilterType.TEXT
  },
  {
    id: filterId.externalMemberEmail,
    label: translation.member_email_filter,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.text,
        includeInSummary: true
      }
    ],
    type: FilterType.TEXT
  }
].filter(filter => !!filter);
